import React from 'react';
import { palettes, MediumLightTitle, Body } from '@indigo-ag/component-module';
import i18next from 'core/i18n';

interface Props {
  letMeMargin?: boolean;
}
export const NoResultsFound = ({ letMeMargin }: Props): JSX.Element => {
  return (
    <div
      className="flex- flex-column"
      style={{ flex: 1, alignItems: 'flex-start', justifyContent: 'center', textAlign: 'center' }}
    >
      <div className="flex- flex-column" style={!letMeMargin ? { paddingTop: 40 } : undefined}>
        <MediumLightTitle style={{ color: palettes.brand.blue.base }}>{i18next.t('noResultsFound')}</MediumLightTitle>
        <Body>{i18next.t('noResultsMessage')}</Body>
      </div>
    </div>
  );
};
